import { VFlow } from 'bold-ui'
import { turquoise } from 'bold-ui/lib/styles/colors'
import { usePecField } from 'components/form/final-form/hooks/useField'
import { IconLabelButton } from 'components/IconLabelButton'
import triaIcon from 'images/acompanhamento/acompanhamento-condicao-saude/ic_tria.svg'
import React from 'react'
import { MetaRoot } from 'util/metaPath'

import {
  AcompanhamentoCondicaoSaudeFormModel,
  TipoVulnerabilidadeEnum,
} from '../model/model-acompanhamentoCondicaoSaude'
import { AcompanhamentoCondicaoSaudeTriaFilterGroup } from './AcompanhamentoCondicaoSaudeTriaFilterGroup'

interface VulnerabilidadeFilterGroup {
  meta: MetaRoot<AcompanhamentoCondicaoSaudeFormModel>
}

export function VulnerabilidadeFilterGroup(props: VulnerabilidadeFilterGroup) {
  const { meta } = props

  const {
    input: { value: vulnerabilidadeSelected, onChange: vulnerabilidadeSelectedOnChange },
  } = usePecField({ name: meta.tipoVulnerabilidadeSelected.absolutePath() })

  const isBotaoTriaAtivo = vulnerabilidadeSelected === TipoVulnerabilidadeEnum.TRIA

  const handleTriaClick = () => {
    vulnerabilidadeSelectedOnChange(isBotaoTriaAtivo ? undefined : TipoVulnerabilidadeEnum.TRIA)
  }

  // TODO Royal Flush: Discutir quando remover o IvcfButton, pois é utilizado no SOAP também.
  return (
    <VFlow vSpacing={0.5}>
      <IconLabelButton
        isActive={isBotaoTriaAtivo}
        handleClick={handleTriaClick}
        img={triaIcon}
        alt='Triagem para Risco de Insegurança Alimentar'
        title='TRIA'
        mainColor={turquoise}
      />
      {isBotaoTriaAtivo && <AcompanhamentoCondicaoSaudeTriaFilterGroup meta={meta} />}
    </VFlow>
  )
}
